import { showNotification } from "@mantine/notifications";
import { axiosGet } from "../../Helpers";

export const deleteData = async (setUpdate, route, setOpened) => {
  console.log("deleteData");
  console.log(route);
  setOpened(false);
  let response = await axiosGet(route);
  if (response.data.status) {
    setUpdate((prev) => !prev);
    showNotification({
      title: "Success",
      message: response.data.message,
      color: "green",
    });
  } else {
    setUpdate(false);
    setOpened(false);
    showNotification({
      title: "Error",
      message: response.data.message,
      color: "red",
    });
  }
  console.log("this is the response", response);
  return response;
};
